import { useEffect, useState } from 'react';

export const useIsMobile = (): { isMobile: boolean } => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 450);

  useEffect(() => {
    const updateIsMobile = () => {
      setIsMobile(window.innerWidth < 450);
    };

    window.addEventListener('resize', updateIsMobile);

    return () => {
      window.removeEventListener('resize', updateIsMobile);
    };
  }, []);

  return {
    isMobile,
  };
};
